import { gsap } from "gsap";
import Swiper from "swiper";
import { Pagination, Navigation, EffectFade, Autoplay } from "swiper/modules";

window.addEventListener(
  "load",
  function () {
    if (document.body.classList.contains("home")) {
      // STATS

      const homeTestimonials = document.querySelector(".home-testimonials");
      const counterEl = document.querySelector(".countdown-number");

      if (homeTestimonials && counterEl) {
        const startCounter = () => {
          if (counterEl.dataset.counted) return;
          counterEl.dataset.counted = "true";

          gsap.to(
            { value: 0 },
            {
              value: 99,
              duration: 2.5,
              ease: "power1.inOut",
              onUpdate: function () {
                counterEl.textContent = Math.floor(this.targets()[0].value);
              },
            },
          );
        };

        if (homeTestimonials.classList.contains("is-in-view")) {
          startCounter();
        } else {
          const observer = new MutationObserver((mutations, obs) => {
            if (homeTestimonials.classList.contains("is-in-view")) {
              startCounter();
              obs.disconnect();
            }
          });

          observer.observe(homeTestimonials, {
            attributes: true,
            attributeFilter: ["class"],
          });
        }
      }

      // TESTIMONIALS

      const homeTestimonialsSlider = new Swiper(
        document.querySelector(".home-testimonials .swiper"),
        {
          modules: [Navigation, Pagination, EffectFade, Autoplay],
          slidesPerView: 1,
          speed: 750,
          effect: "fade",
          autoplay: {
            delay: 7000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".slider-next",
            prevEl: ".slider-prev",
          },
        },
      );
    }
  },
  false,
);
